import React,{useState} from 'react'
import { Card1Style } from './TotalNoCard.styled'

const TotalNoCard = ({ heading, total="", onClick=()=>{}, isSelected=false }) => {
  
  return (
    <Card1Style>
        <div className={`card-container ${isSelected ? 'selected' : ''}`} onClick={onClick}>
            <h2 className='heading'>{heading}</h2>
            <p className={total.length>38?"total-sm":'total'}>{total}</p>
        </div>
    </Card1Style>
  )
}

export default TotalNoCard